/* eslint-disable security/detect-unsafe-regex */
export const ruleRegex = /^(.+?)\[(.+)\]$/;
export const numericRegex = /^[0-9]+$/;
export const integerRegex = /^\-?[0-9]+$/;
export const decimalRegex = /^\-?[0-9]*\.?[0-9]+$/;
export const emailRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
export const emailRegex2 = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,3}))$/;
export const emailRegexNew = /^(([a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*)|(".+"))@(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,})$/i;
export const alphaRegex = /^[a-z]+$/i;
export const alphaNumericRegex = /^[a-z0-9]+$/i;
export const alphaDashRegex = /^[a-z0-9_\-]+$/i;
export const naturalRegex = /^[0-9]+$/i;
export const naturalNoZeroRegex = /^[1-9][0-9]*$/i;
export const ipRegex = /^((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){3}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})$/i;
export const base64Regex = /[^a-zA-Z0-9\/\+=]/i;
export const numericDashRegex = /^[\d\-\s]+$/;
export const urlRegex = /^((http|https):\/\/(\w+:{0,1}\w*@)?(\S+)|)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?$/;
export const dateRegex = /\d{4}-\d{1,2}-\d{1,2}/;
export const phone = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
export const phoneMask = /\(\d{3}\)\d{3}-\d{4}$/;
export const zipRegex = /^[0-9]{5}(?:-[0-9]{4})?$/;
export const poBox = /(?:P(?:ost(?:al)?)?[\.\-\s]*(?:(?:O(?:ffice)?[\.\-\s]*)?B(?:ox|in|\b|\d)|o(?:ffice|\b)(?:[-\s]*\d)|code)|box[-\s\b]*\d)/i;
